import * as Actions from "./_ActionTypes";
import * as Pre from "./_PreActionNames";
const _preActionName = Pre.POWER_SWITCH;

export function ToggleSwitch(deviceId, deviceUId, accessToken) {
  return {
    type: _preActionName + Actions.TOGGLE_SWITCH,
    accessToken,
    payload: { deviceId },
    socket: { send: true, keepSocket: true },
  };
}

export function turnOn(deviceId = 0, deviceUId = null, accessToken) {
  var payload = { deviceId, deviceUId, value: true };

  return {
    type: _preActionName + Actions.UPDATE_VALUE,
    accessToken: accessToken,
    payload,
    socket: { send: true, keepSocket: true },
  };
}

export function turnOff(deviceId = 0, deviceUId = null, accessToken) {
  var payload = { deviceId, deviceUId, value: false };

  return {
    type: _preActionName + Actions.UPDATE_VALUE,
    accessToken: accessToken,
    payload,
    socket: { send: true, keepSocket: true },
  };
}
